import { api } from '@/modules/apiv2';

export default {
  state: {
    downloads: [],
    download: null,
  },

  getters: {
    downloads(state) {
      return state.downloads;
    },

    download(state) {
      return state.download;
    },
  },

  mutations: {
    setDownloads(state, downloads) {
      state.downloads = downloads;
    },

    setDownload(state, download) {
      state.download = download;
    },
  },

  actions: {
    approveDownload({ commit, getters }, exportId) {
      const endpoint = getters.exportsApprovalEndpoint;

      return api
        .put(`${endpoint}/${exportId}/approve`)
        .then((data) => {
          commit('setDownload', data);
          return data;
        })
        .catch((error) => {
          throw error;
        });
    },

    getDownloads({ commit, getters }) {
      const endpoint = getters.exportsEndpoint;

      return api
        .get(`${endpoint}`)
        .then((data) => {
          commit('setDownloads', data);
          return data;
        })
        .catch((error) => {
          throw error;
        });
    },

    getDownload({ commit, getters }, exportId) {
      const endpoint = getters.exportsEndpoint;

      return api
        .get(`${endpoint}/${exportId}`)
        .then((data) => {
          commit('setDownload', data);
          return data;
        })
        .catch((error) => {
          throw error;
        });
    },

    createDownload({ commit, getters }, data) {
      const endpoint = getters.devicesEndpoint;

      return api
        .post(`${endpoint}/${data.deviceId}/events/${data.eventId}`, data)
        .then((data) => {
          commit('setDownload', data);
          return data;
        })
        .catch((error) => {
          throw error;
        });
    },

    deleteDownload({ commit, getters }, exportId) {
      const endpoint = getters.exportsEndpoint;

      return api
        .delete(`${endpoint}/${exportId}`)
        .then((response) => {
          commit('setDownload', null);
          return response;
        })
        .catch((error) => {
          throw error;
        });
    },
  },
};
